export default __webpack_public_path__ + "static/Policy Contract_i-MedicalCard (EV)-5fccb6ed8135ee9810536a12c323fd5c.pdf";